export default __webpack_public_path__ + "static/media/Information_filled.f6f1b15f.svg";